const UserGroup=({id,codigo,name})=>{
    return (<div className="text-center text-sm bg-slate-400/40 rounded-sm p-[2px] px-[2px]">
        {name}
        </div>)
}

export default UserGroup